export const chartExtend = {
  series: {
    itemStyle: {
      normal: {
        color: '#fd9b21',
      },
    },
  },
  yAxis: {
    splitLine: {
      lineStyle: {
        color: '#DADEE3',
        width: 0.2,
      },
    },
    axisLabel: {
      formatter: function (value) {
        let str = value;
        if (value >= 10000) {
          const m = str / 10000;
          str = parseFloat(m.toFixed(1)) + 'w';
        }
        return str;
      },
    },
  },
  xAxis: {
    splitLine: {
      lineStyle: {
        color: '#DADEE3',
        width: 0.2,
      },
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: '#fd9b21',
        width: 2,
      },
    },
    axisLabel: {
      textStyle: {
        color: '#262626',
        align: 'center',
      },
    },
    axisTick: {
      alignWithLabel: true,
    },
  },
};
